import { client } from "api";
import { Contact } from "models/Contact";
import { CustomerReference } from "models/Order";

export type UpdateCustomerReferenceRequest = { orderId: string; contact: Contact | null };
export type UpdateCustomerReferenceResponse = CustomerReference;

export const updateCustomerReference = ({ orderId, ...params }: UpdateCustomerReferenceRequest) =>
  client
    .put<UpdateCustomerReferenceResponse>(`/order/${orderId}/customer-reference`, params)
    .then((res) => res.data);
